import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecurrenceScheduleComponent } from './recurrence-schedule.component';
import { RruleModule } from '../rrule/rrule.module';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    RecurrenceScheduleComponent
  ],
  imports: [
    CommonModule,
    RruleModule,
    SharedModule,
    FormsModule,
  ],
  exports: [
    RecurrenceScheduleComponent
  ]
})
export class RecurrenceScheduleModule { }
